import React from 'react'
import { Ordering } from 'storfox-filter'

import { INVENTORY_LOG_COLUMNS as tableColumns } from './InventoryLogTable'

import { FILTER_NAME as name } from '../../constants'

export const inventoryLogOrderingOptions = {
  name,
  tableColumns
}

function InventoryLogOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default InventoryLogOrderingForm
